import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

import './Nav.css';
import { useTranslation } from 'react-i18next';

const EcomNav = ({ links = [] }) => {
  const {t} = useTranslation();
  const currentLocation = useLocation();
  const [Toggle, setToggle] = React.useState(false);
  const OpenSidebar = () => {
    setToggle(true);
  };
  const closeSidebar = () => {
    setToggle(false);
  };
  return (
    <>
      <div
        className={`ecom_mob_nav ${
          currentLocation.pathname === '/integrations'
            ? 'mob_nav_show'
            : 'mob_nav_show'
        }`}
        onClick={OpenSidebar}
      >
        <i className="fas fa-cog"></i>
      </div>
      {/* <div className='ecom-nav-overlay'></div> */}
      <nav
        className={`${Toggle ? 'ecom-sidenav ecom-nav-show' : 'ecom-sidenav'}`}
      >
        <div className="sidenav-heading">
          <h4>{t("Settings.my_app")}</h4>
          <i className="fas fa-cog"></i>
          <i className="fas fa-times" onClick={closeSidebar}></i>
        </div>
        <div className="sidenav-heading bg-gray">
          <h2>{t("Settings.seebiz_app_store")}</h2>
          <Link to="/integrations">{t("Settings.view_all")}</Link>
        </div>
        {links.map((link, index) =>
          link.show ? null : (
            <NavLink
              key={index}
              exact
              to={link.path}
              className="ecom-sidenav--link"
              activeClassName="ecom-sidenav--link active"
              title={link.title}
            >
              {link.title}
            </NavLink>
          )
        )}
        {/* <div className="sidenav-heading bg-gray">
          <h2>Preferences</h2>
        </div> */}
      </nav>
    </>
  );
};

export default EcomNav;
